module.exports = __webpack_public_path__ + "media/start_page3.e58a5d9b.mp3";